import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './modules/shared.module';

import { AppComponent } from './app.component';
import { CardTokenComponent } from './components/card-token/card-token.component';

import { FormsModule } from '@angular/forms';
import { NgCreditCardModule } from 'angular-credit-card';
import { LoadingComponent } from './components/loading/loading.component';

@NgModule({
  declarations: [AppComponent, CardTokenComponent, LoadingComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    SharedModule,
    NgCreditCardModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
